import { createAsyncThunk } from '@reduxjs/toolkit';
import actionLogApi from '~/apis/action-log';
import { IParamsActionLog, IResponseActionLogs } from '~/utils/interface/actionLog';

export const handleGetListActionLog = createAsyncThunk<IResponseActionLogs, IParamsActionLog>(
  'GEt_ACTION_LOG_LIST',
  async (params: IParamsActionLog = {}, { rejectWithValue }) => {
    try {
      const res = await actionLogApi.getActionLogs(params);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
